var cov_i14yx47vz = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/Radio.ts",
      hash = "40d920a22e9dd1dab7f7ba80537f284d47de6813",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/Radio.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from '../Checkbox/CheckItem';
export default checkItem('radio');